module.exports = __webpack_public_path__ + "static/media/hero-clouds.515f00b3.jpg";